import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContentValues } from "../redux/slice/ContentSlice";
import api from "../utils/api";

function ChapterContent({ selection, title, activity }) {
  const [contentArray, setContentArray] = useState([]);
  const [chapterArray, setChapterArray] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Unites = selection;
  const section = activity.toLowerCase().trim();
  const userId = JSON.parse(localStorage.getItem("postUser"))?._id;
  const completeChapterList = useSelector((state) => state.score.value);
  const classContent = useSelector((state) => state.selectClass.value);
  const className = classContent.classType;
  // const className = "Demo";

  // İçerik URL buradan yapılır
  useEffect(() => {
    const fetchContent = async () => {
      let getUrl = "";
      if (activity.toLowerCase().trim() === "vocabulary") {
        getUrl = "get_chapterVocabulary";
      }
      if (activity.toLowerCase().trim() === "grammar") {
        getUrl = "get_grammar";
      }
      if (activity.toLowerCase().trim() === "reading") {
        getUrl = "get_reading";
      }
      if (activity.toLowerCase().trim() === "speaking") {
        getUrl = "get_speaking";
      }

      try {
        const res = await api.get(getUrl, {
          params: { Unites, section, userId, className },
        });
        if (res.status === 200) {
          setContentArray(res.data.data);
        }
      } catch (error) {
        console.error("Veri alınırken hata oluştu:", error);
      }
    };

    fetchContent();
  }, [Unites, section, activity]);

  // Tamamlanan chapter ile tamamlanmayan chapter ayıklama
  const resultContent = (completeChapterList, contentArray) => {
    if (contentArray && contentArray.length > 0) {
      const unit = contentArray[0].Unites;
      let UnitArray = [];

      if (completeChapterList && Array.isArray(completeChapterList)) {
        // completeChapterList içinde unit değeri eşleşenleri al
        UnitArray = completeChapterList.filter(
          (element) => element.unit === unit,
        );
        return UnitArray;
      }
    }
    return [];
  };

  useEffect(() => {
    const resultArray = resultContent(completeChapterList, contentArray);
    setChapterArray(resultArray || []);
  }, [contentArray, completeChapterList]);

  // Chapter'ın durumunu kontrol et (completed, homework, normal)
  const getChapterStatus = (chapter) => {
    if (!chapterArray || chapterArray.length === 0) return null;

    // Büyük/küçük harf duyarsız karşılaştırma
    const foundChapter = chapterArray.find(
      (item) => item.chapter.toLowerCase() === chapter.toLowerCase(),
    );

    if (!foundChapter) return null;

    return foundChapter.completedChapter ? "completed" : "homework";
  };

  // İlgili chapter buradan seçilir
  const handleContent = (value) => {
    dispatch(getContentValues(value));
    if (activity.toLowerCase().trim() === "vocabulary") {
      navigate("/vocabulary");
    }
    if (activity.toLowerCase().trim() === "grammar") {
      navigate("/grammar");
    }
    if (activity.toLowerCase().trim() === "reading") {
      navigate("/reading");
    }
    if (activity.toLowerCase().trim() === "speaking") {
      navigate("/speaking");
    }
  };

  return (
    <div className="flex flex-col gap-2.5">
      {contentArray?.map((card, index) => {
        const status = getChapterStatus(card.chapter);

        return (
          <div
            key={index}
            className="transition-all duration-200 hover:translate-x-1"
          >
            <div className="card flex justify-between items-center bg-yellow-500 p-3 rounded-xl">
              <div
                className="icon h-12 w-12 md:h-14 md:w-14 rounded-full flex justify-center
               items-center text-2xl bg-purple-500"
              >
                {card.emoji}
              </div>
              <div className="flex flex-col gap-0.5 flex-1 mx-3">
                <p
                  className="border-b-2 border-purple-500 font-semibold text-gray-700 
                text-base md:text-lg pb-0.5 w-fit flex "
                >
                  {card.title}
                  {status === "completed" && (
                    <span
                      className="ml-2 text-xs hidden sm:block text-white
                     font-medium py-1 px-3 rounded-lg bg-green-600"
                    >
                      completed
                    </span>
                  )}
                  {status === "homework" && (
                    <span
                      className="bg-blue-500 ml-2 text-xs  hidden sm:block text-white
                     font-medium py-1 px-3 rounded-lg"
                    >
                      HomeWork
                    </span>
                  )}
                </p>
                <p className="text-xs md:text-sm hidden sm:block text-gray-700">
                  {card.description}
                </p>
                <p className="sm:hidden flex">
                  {status === "completed" && (
                    <span
                      className=" text-xs  text-white
                     font-medium py-1 px-3 rounded-lg bg-green-600"
                    >
                      completed
                    </span>
                  )}
                  {status === "homework" && (
                    <span
                      className="bg-blue-500  text-xs text-white
                     font-medium py-1 px-3 rounded-lg"
                    >
                      HomeWork
                    </span>
                  )}
                </p>
              </div>
              <button
                className="px-4 py-2 text-sm md:text-base bg-purple-500
                 hover:bg-purple-600 font-medium rounded-xl text-white transition-colors"
                onClick={() => handleContent(card)}
              >
                {status === "completed" ? "Tekrar Yap" : "Let's Start"}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ChapterContent;
